<div
    class="
grid-product 
grid-new 
grid-product-wrap--{{ templateNameFirst | lowercase }} 
studio-product-template
{{ templateNameFirst | lowercase }} 
{{ templateName | lowercase }}"
    [ngClass]="defaultTemplateAttachment ? 'default-template-active' : ''"
>
    <ul class="{{ templateNameFirst | lowercase }}-wrap {{ skeletonNoDetails }}">
        <li *ngFor="let product of products; trackBy: trackByIndex" class="{{ templateNameFirst | lowercase }}-item">
            @if (studioTemplateConfig.multipleMedias) {
                <product-view-mono-studio
                    class="p-view"
                    [productId]="product"
                    [config]="studioTemplateConfig"
                    [categoryConfig]="categoryConfiguration"
                    [productStyle]="productStyle"
                    [elementIndex]="elementIndex"
                    [defaultImageType]="elementDefaultImageTypes?.[product]"
                    (clickActionBadge)="addToCartSheet($event)"
                ></product-view-mono-studio>
            } @else {
                <product-view
                    class="p-view"
                    [productId]="product"
                    [config]="studioTemplateConfig"
                    [categoryConfig]="categoryConfiguration"
                    [productStyle]="productStyle"
                    [elementIndex]="elementIndex"
                    [defaultImageType]="elementDefaultImageTypes?.[product]"
                    (clickActionBadge)="addToCartSheet($event)"
                ></product-view>
            }
        </li>
    </ul>
</div>
